import { useQuery } from 'react-query';
import { API } from 'api';

export interface IEmployerReportItem {
  id: string;
  createdOn: number;
  employerName: string;
  eid: string;
  type: string;
  file: string;
  fileName: string;
  status: string;
  reconciliationStatus?: string;
  withdrawalCycleId?: string;
  isHRMSIntegrated: boolean;
}

export interface IEmployerReportListData {
  payload: {
    page?: number;
    from?: number;
    to?: number;
    type?: string;
    target?: string; // Employer ID (eid) - matches backend API parameter name
  };
  data: {
    data: {
      data: IEmployerReportItem[];
      count: number;
    };
  };
}

export const initEmployerReportListPayload: IEmployerReportListData['payload'] = {
  page: 1,
  type: 'all',
};

const getEmployerReportListData = (data: IEmployerReportListData['payload']) => {
  return API.get()('/api/admin/financeFiles/employerReport', data);
};

export const useEmployerReportListData = (data: IEmployerReportListData['payload']) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useQuery(['employerReports', data], (): any => getEmployerReportListData(data), {
    select: (response: IEmployerReportListData['data']) => {
      return response.data;
    },
  });
};
